import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import { Box, styled } from '@mui/material';

export const typeUrl = {
  substation: 'umspannwerk',
  measurmentPoint: 'messpunkt',
  measurmentDevice: 'messgeraet',
};

export const StyledContentWrapper = styled(Box)(() => {
  return {
    width: '100%',
    paddingTop: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
  };
});

export const StyledContent = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
  };
});
export const StyledContentTitle = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  };
});

export const StyledHeaderContainer = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const StyledSearchContainer = styled(Box)(() => {
  return {
    display: 'flex',
    alignItems: 'center',
    marginTop: '1.5rem',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_page_gap_xxs,
  };
});

export const StyledManagementModals = styled(Box)(() => {
  return {
    overflowY: 'auto',
    width: '100%',
  };
});
